import http from "../../http-common";

export default class EventVideoPage {
  getVideoPage(eventCode: string) {
    let url = `/events/video/${eventCode}`;

    return http.get(url);
  }
}